import React from 'react';

import { FieldWrapper } from '@qality/common-components/src/atoms/FieldWrapper';
import { Header } from '@qality/common-components/src/atoms/Header';
import { Icon } from '@qality/common-components/src/atoms/Icon';
import { Link } from '@qality/common-components/src/atoms/Link';
import { downloadExampleCSV } from '@qality/common-components/src/molecules/ImportTestCasesForm/utils';
import { CreatableSelect } from '@qality/common-components/src/molecules/final-form/CreatableSelect';
import CsvDropzoneWithFilesField from '@qality/common-components/src/molecules/final-form/CsvDropzoneWithFilesField';
import { FieldError } from '@qality/common-components/src/molecules/final-form/FieldError';
import { ProjectSelect } from '@qality/common-components/src/molecules/final-form/ProjectSelect';
import { TextField } from '@qality/common-components/src/molecules/final-form/TextField';
import { StorageOfUniqueServices } from '@qality/common-service';

import { ProjectSelectError } from './ProjectSelectError';
import { UploadFilesStyled } from './UploadFiles.styled';

const IMPORT_DOCUMENTATION_LINK =
  'https://soldevelo.atlassian.net/wiki/spaces/QS/pages/2880340026/Import+test+cases';

export const UploadFilesView = () => {
  const ICON_PATH =
    StorageOfUniqueServices.get('URLService').getQAlityIssueIcon();

  const openImportDocumentation = async () => {
    window.open(IMPORT_DOCUMENTATION_LINK, '_blank');
  };

  return (
    <UploadFilesStyled>
      <Header spacing='medium'>Files set up</Header>
      <p>
        You are about to start CSV import. To learn more about CSV import go to{' '}
        <Link onClick={openImportDocumentation}>
          Import Test Cases section in Documentation
        </Link>{' '}
        or <Link onClick={downloadExampleCSV}>Download CSV template</Link>
      </p>
      <p>
        Test cases from CSV files will be imported as{' '}
        <Icon src={ICON_PATH} alt='Icon' /> QAlity Test issues
      </p>
      <FieldWrapper size='large'>
        <ProjectSelect
          name='project'
          label='Import to Project'
          placeholder='Select project'
          isClearable={false}
          useAllOption={false}
          isRequired
        />
      </FieldWrapper>
      <ProjectSelectError />

      <FieldWrapper>
        <CsvDropzoneWithFilesField
          name='file'
          label='Select CSV file'
          isRequired
        />
        <FieldError name='file' />
      </FieldWrapper>

      <FieldWrapper size='medium'>
        <TextField name='encoding' label='Encoding' isRequired />
        <FieldError name='encoding' />
      </FieldWrapper>

      <FieldWrapper size='medium'>
        <div className='hide-focus-wrapper'>
          <CreatableSelect label='CSV delimiter' name='delimiter' isRequired />
          <FieldError name='delimiter' />
        </div>
      </FieldWrapper>
    </UploadFilesStyled>
  );
};
